module.exports = __webpack_public_path__ + "static/media/noprofile.365ff9de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/noprofile.svg
// module id = 2429
// module chunks = 7